module.exports = __webpack_public_path__ + "static/media/assignCardSmall.343ba43b.svg";